import { ReactNode } from 'react';
import { lt } from '@mews/framework';
import { ActionToolbar, ActionToolbarButton, IconName, Stack, StackItem } from '@optimus-web/core';

interface Props {
    resetRowSelection: () => void;
    rightSide?: ReactNode;
    selectedRows: number;
}

export const BulkActionToolbar = ({ resetRowSelection, rightSide, selectedRows }: Props) => {
    return (
        <ActionToolbar
            disabled={selectedRows < 1}
            leftSide={
                selectedRows > 0 ? (
                    <Stack itemAlignment="center" spacing="200">
                        <StackItem>{lt('SelectedItems', { count: selectedRows })}</StackItem>
                        <StackItem>
                            <ActionToolbarButton icon={IconName.ClearSelection} onClick={resetRowSelection}>
                                {lt('ClearSelection')}
                            </ActionToolbarButton>
                        </StackItem>
                    </Stack>
                ) : null
            }
            rightSide={rightSide}
        />
    );
};
